(function () {
  function enableDragPause(track, viewport) {
    if (!track || !viewport) return;
    var isDown = false, startX = 0, scrollLeft = 0, wasPlaying = true;

    function pause() { track.style.animationPlayState = 'paused'; }
    function resume() { if (!isDown) track.style.animationPlayState = 'running'; }

    viewport.addEventListener('mouseenter', pause);
    viewport.addEventListener('mouseleave', resume);
    viewport.addEventListener('touchstart', pause, { passive: true });
    viewport.addEventListener('touchend', function () { setTimeout(resume, 400); }, { passive: true });

    viewport.addEventListener('mousedown', function (e) {
      isDown = true;
      pause();
      viewport.style.cursor = 'grabbing';
      startX = e.pageX - viewport.offsetLeft;
      scrollLeft = viewport.scrollLeft || 0;
    });
    window.addEventListener('mouseup', function () {
      if (isDown) { isDown = false; viewport.style.cursor = 'grab'; resume(); }
    });
    viewport.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - viewport.offsetLeft;
      var walk = (x - startX);
      var currentTransform = track.style.transform;
      track.style.transform = 'translateX(' + walk + 'px)';
    });
    viewport.style.cursor = 'grab';
  }

  function initAll() {
    document.querySelectorAll('[data-autoscroll-viewport]').forEach(function (viewport) {
      var track = viewport.querySelector('[data-autoscroll-track]');
      enableDragPause(track, viewport);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

/* DUSKY'S SHRINE ANNIVERSARY CAMPAIGN — managed block; Cosmos only */
(function () {
  'use strict';

  var STARTS_AT = new Date('2026-08-20T18:30:00.000Z');
  var ENDS_AT = new Date('2026-08-23T18:30:00.000Z');
  var campaigns = [
    {
      name: 'Brad Thor',
      handle: 'brad-thor',
      desktop: 'https://cdn.shopify.com/s/files/1/0795/3367/0457/files/anniversary-brad-thor-2026-08-21-v3-desktop.jpg?v=1787262318',
      mobile: 'https://cdn.shopify.com/s/files/1/0795/3367/0457/files/anniversary-brad-thor-2026-08-21-v3-mobile.jpg?v=1787262339'
    },
    {
      name: 'Sharon M. Draper',
      handle: 'sharon-m-draper',
      desktop: 'https://cdn.shopify.com/s/files/1/0795/3367/0457/files/anniversary-sharon-m-draper-2026-08-21-v3-desktop.jpg?v=1787262348',
      mobile: 'https://cdn.shopify.com/s/files/1/0795/3367/0457/files/anniversary-sharon-m-draper-2026-08-21-v3-mobile.jpg?v=1787262357'
    },
    {
      name: 'Golden Kamuy',
      handle: 'golden-kamuy',
      desktop: 'https://cdn.shopify.com/s/files/1/0795/3367/0457/files/anniversary-golden-kamuy-2026-08-21-v3-desktop.jpg?v=1787262369',
      mobile: 'https://cdn.shopify.com/s/files/1/0795/3367/0457/files/anniversary-golden-kamuy-2026-08-21-v3-mobile.jpg?v=1787262327'
    }
  ];

  function active() {
    // Replaced by the schedule-driven anniversary-automation.js module.
    return false;
  }

  function addStyles() {
    if (document.getElementById('ds-anniversary-current-style')) return;
    var style = document.createElement('style');
    style.id = 'ds-anniversary-current-style';
    style.textContent = [
      '#ds-anniversary-mobile-bar{display:none;background:#073c3d;color:#fff7e6;border-bottom:2px solid #c9a85e;min-height:42px;align-items:center;justify-content:center;text-align:center;padding:7px 42px 7px 14px;position:relative;z-index:60;font-size:13px;font-weight:800;letter-spacing:.02em}',
      '#ds-anniversary-mobile-bar a{color:inherit;text-decoration:none}',
      '#ds-anniversary-mobile-bar strong{color:#f1cf77}',
      '@media(max-width:768px){#ds-anniversary-mobile-bar{display:flex}}',
      '.ds-anniversary-tile{position:relative!important}',
      '.ds-anniversary-tile-badge{position:absolute;z-index:8;top:10px;right:10px;background:#c9a85e;color:#052f30;border:3px solid #fff7e6;border-radius:999px;min-width:84px;min-height:84px;display:flex;align-items:center;justify-content:center;text-align:center;padding:8px;font-size:17px;line-height:1.05;font-weight:900;box-shadow:0 5px 16px rgba(0,28,29,.38);pointer-events:none}',
      '@media(max-width:768px){.ds-anniversary-tile-badge{min-width:44px;min-height:44px;padding:3px;border-width:2px;font-size:9px;top:4px;right:4px}}',
      '#ds-anniversary-popup{position:fixed;inset:0;z-index:100000;background:rgba(0,0,0,.72);display:none;align-items:center;justify-content:center;padding:18px}',
      '#ds-anniversary-popup.is-open{display:flex}',
      '.ds-anniversary-dialog{position:relative;width:min(1120px,96vw);max-height:94vh;overflow:auto;background:#f5f5f5;color:#000;border:2px solid #fff;border-radius:22px;box-shadow:0 24px 80px rgba(0,0,0,.55)}',
      '.ds-anniversary-close{position:absolute;z-index:5;top:10px;right:12px;width:40px;height:40px;border:2px solid #fff;border-radius:50%;background:#2e2e2e;color:#fff;font-size:25px;cursor:pointer}',
      '.ds-anniversary-slide{display:none;grid-template-columns:minmax(0,1.2fr) minmax(300px,.8fr);align-items:stretch}',
      '.ds-anniversary-slide.is-active{display:grid}',
      '.ds-anniversary-media img{display:block;width:100%;height:100%;min-height:470px;object-fit:cover}',
      '.ds-anniversary-copy{padding:52px 36px 36px;display:flex;flex-direction:column;justify-content:center;text-align:center}',
      '.ds-anniversary-copy h2{color:#000;margin:6px 0 10px;font-size:clamp(30px,4vw,52px);line-height:1.02}',
      '.ds-anniversary-eyebrow{color:#2e2e2e;text-transform:uppercase;letter-spacing:.14em;font-weight:900;margin:0}',
      '.ds-anniversary-count-label{font-weight:900;margin:22px 0 8px}',
      '.ds-anniversary-countdown{display:grid;grid-template-columns:repeat(4,1fr);gap:7px}',
      '.ds-anniversary-countdown span{background:#2e2e2e;color:#fff;border:1px solid #fff;border-radius:10px;padding:10px 4px;font-size:25px;font-weight:900}',
      '.ds-anniversary-countdown small{display:block;font-size:10px;text-transform:uppercase;letter-spacing:.05em}',
      '.ds-anniversary-cta{display:inline-block;margin:20px auto 0;padding:13px 24px;background:#2e2e2e;color:#fff!important;border:1px solid #fff;border-radius:999px;text-decoration:none!important;font-weight:900}',
      '.ds-anniversary-threshold{color:#2e2e2e;font-size:12px;margin:14px 0 0;opacity:.9}',
      '.ds-anniversary-threshold p{margin:3px 0}',
      '@media(max-width:900px){#ds-anniversary-popup{padding:6px;overflow-x:hidden}.ds-anniversary-dialog{box-sizing:border-box;width:calc(100vw - 12px);max-width:calc(100vw - 12px);max-height:92dvh;overflow-x:hidden;border-radius:14px}.ds-anniversary-slide,.ds-anniversary-media,.ds-anniversary-copy{box-sizing:border-box;width:100%;max-width:100%;min-width:0}.ds-anniversary-media picture{display:block;width:100%;max-width:100%;overflow:hidden}.ds-anniversary-close{top:6px;right:7px;width:32px;height:32px;font-size:20px}.ds-anniversary-slide.is-active{display:block}.ds-anniversary-media img{min-height:0;height:min(30dvh,220px);aspect-ratio:auto;object-fit:cover}.ds-anniversary-copy{padding:12px 10px 14px}.ds-anniversary-copy h2{margin:3px 0 6px;font-size:21px;line-height:1.05}.ds-anniversary-eyebrow{font-size:10px}.ds-anniversary-copy>p{font-size:12px;line-height:1.35;margin:6px 0}.ds-anniversary-count-label{margin:10px 0 5px!important;font-size:10px!important}.ds-anniversary-countdown{grid-template-columns:repeat(4,minmax(0,1fr));gap:4px}.ds-anniversary-countdown span{min-width:0;padding:5px 1px;border-radius:7px;font-size:15px;line-height:1}.ds-anniversary-countdown small{font-size:7px}.ds-anniversary-cta{margin:10px auto 0;padding:9px 14px;font-size:12px}.ds-anniversary-threshold{font-size:9px!important;margin:8px 0 0!important}}'
    ].join('');
    document.head.appendChild(style);
  }

  function installMobileBar() {
    if (document.getElementById('ds-anniversary-mobile-bar')) return;
    var bar = document.createElement('div');
    bar.id = 'ds-anniversary-mobile-bar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Anniversary sale announcements');
    document.body.insertBefore(bar, document.body.firstChild);
    var index = 0;
    function render() {
      var item = campaigns[index % campaigns.length];
      bar.innerHTML = '<a href="/collections/' + item.handle + '"><strong>20% OFF</strong> On ' + item.name + ' collection Till 24 Aug</a>';
      index += 1;
    }
    render();
    window.setInterval(render, 4000);
  }

  function installTileBadges() {
    var main = document.getElementById('main-content') || document.querySelector('main');
    if (!main) return;
    var activePaths = new Set(campaigns.map(function (item) { return '/collections/' + item.handle; }));
    main.querySelectorAll('.ds-anniversary-tile-badge,.ds-anniversary-badge').forEach(function (badge) {
      var anchor = badge.closest('a[href]');
      var pathname = '';
      try { pathname = anchor ? new URL(anchor.href, location.origin).pathname.replace(/\/$/, '') : ''; } catch (e) {}
      if (!activePaths.has(pathname)) {
        var formerTile = badge.parentElement;
        badge.remove();
        if (formerTile) formerTile.classList.remove('ds-anniversary-tile', 'ds-anniversary-badged');
      }
    });
    campaigns.forEach(function (item) {
      main.querySelectorAll('a[href]').forEach(function (link) {
        var pathname;
        try { pathname = new URL(link.href, location.origin).pathname.replace(/\/$/, ''); } catch (e) { return; }
        if (pathname !== '/collections/' + item.handle) return;
        var tile = link;
        if (tile.querySelector(':scope > .ds-anniversary-tile-badge')) return;
        tile.classList.add('ds-anniversary-tile');
        var badge = document.createElement('span');
        badge.className = 'ds-anniversary-tile-badge';
        badge.setAttribute('aria-label', item.name + ' collection is 20% off');
        badge.innerHTML = '20%<br>OFF';
        tile.appendChild(badge);
      });
    });
  }

  function countdownMarkup() {
    return '<p class="ds-anniversary-count-label">SALE ENDS IN:</p><div class="ds-anniversary-countdown"><span data-ds-days>0<small>Days</small></span><span data-ds-hours>00<small>Hours</small></span><span data-ds-minutes>00<small>Minutes</small></span><span data-ds-seconds>00<small>Seconds</small></span></div>';
  }

  function installPopup() {
    if (document.getElementById('ds-anniversary-popup')) return;
    var popup = document.createElement('div');
    popup.id = 'ds-anniversary-popup';
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-modal', 'true');
    popup.setAttribute('aria-label', 'Anniversary collection sale');
    popup.setAttribute('aria-hidden', 'true');
    var slides = campaigns.map(function (item, index) {
      return '<section class="ds-anniversary-slide' + (index === 0 ? ' is-active' : '') + '" data-ds-slide="' + index + '"><div class="ds-anniversary-media"><picture><source media="(max-width:768px)" srcset="' + item.mobile + '"><img src="' + item.desktop + '" alt="' + item.name + ' collection 20% off anniversary sale banner" width="1600" height="900"></picture></div><div class="ds-anniversary-copy"><p class="ds-anniversary-eyebrow">SALE !!</p><h2>20% Off<br>' + item.name + ' Collection</h2>' + countdownMarkup() + '<a class="ds-anniversary-cta" href="/collections/' + item.handle + '">Shop ' + item.name + ' Collection</a><div class="ds-anniversary-threshold"><p>Free delivery For Purchases above ₹999.</p><p>Extra 10% Off For Purchases above ₹1,499.</p><p>Extra 20% Off For Purchases above ₹2,499.</p></div></div></section>';
    }).join('');
    popup.innerHTML = '<div class="ds-anniversary-dialog"><button class="ds-anniversary-close" type="button" aria-label="Close anniversary sale">×</button>' + slides + '</div>';
    document.body.appendChild(popup);
    var current = 0;
    var slideNodes = popup.querySelectorAll('[data-ds-slide]');
    function showSlide(next) {
      current = next % slideNodes.length;
      slideNodes.forEach(function (node, index) { node.classList.toggle('is-active', index === current); });
    }
    window.setInterval(function () { if (popup.classList.contains('is-open')) showSlide(current + 1); }, 7000);
    function close() {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    function open() {
      if (popup.classList.contains('is-open')) return;
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      popup.dataset.lastOpenedAt = String(Date.now());
      document.body.style.overflow = 'hidden';
    }
    popup.querySelector('.ds-anniversary-close').addEventListener('click', close);
    popup.addEventListener('click', function (event) { if (event.target === popup) close(); });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape') close(); });
    var sevenMinutes = 7 * 60 * 1000;
    var nextPopupKey = 'ds-anniversary-next-popup-v2';
    var sessionShownKey = 'ds-anniversary-popup-shown-v2';
    var nextAtFallback = 0;

    function readNextAt() {
      try { return Number(localStorage.getItem(nextPopupKey) || 0); } catch (e) { return nextAtFallback; }
    }

    function writeNextAt(value) {
      nextAtFallback = value;
      popup.dataset.nextPopupAt = String(value);
      try { localStorage.setItem(nextPopupKey, String(value)); } catch (e) {}
    }

    function sessionHasSeenPopup() {
      try { return sessionStorage.getItem(sessionShownKey) === '1'; } catch (e) { return popup.dataset.sessionShown === 'true'; }
    }

    function markSessionSeen() {
      popup.dataset.sessionShown = 'true';
      try { sessionStorage.setItem(sessionShownKey, '1'); } catch (e) {}
    }

    function openAndReschedule() {
      open();
      markSessionSeen();
      writeNextAt(Date.now() + sevenMinutes);
    }

    function checkDuePopup() {
      var now = Date.now();
      var nextAt = readNextAt();
      if (!nextAt || nextAt > now + sevenMinutes) {
        writeNextAt(now + sevenMinutes);
        return;
      }
      if (now >= nextAt) openAndReschedule();
    }

    function startPopupSchedule() {
      if (!sessionHasSeenPopup()) {
        window.setTimeout(openAndReschedule, 2000);
      } else {
        checkDuePopup();
      }

      window.setInterval(checkDuePopup, 1000);
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) checkDuePopup();
      });
      window.addEventListener('pageshow', checkDuePopup);
    }

    window.DSAnniversaryPopup = {
      open: openAndReschedule,
      close: close,
      check: checkDuePopup
    };

    startPopupSchedule();
  }

  function updateCountdowns() {
    var remaining = Math.max(0, ENDS_AT.getTime() - Date.now());
    var days = Math.floor(remaining / 86400000);
    var hours = Math.floor(remaining / 3600000) % 24;
    var minutes = Math.floor(remaining / 60000) % 60;
    var seconds = Math.floor(remaining / 1000) % 60;
    document.querySelectorAll('[data-ds-days]').forEach(function (node) { node.firstChild.nodeValue = String(days); });
    document.querySelectorAll('[data-ds-hours]').forEach(function (node) { node.firstChild.nodeValue = String(hours).padStart(2, '0'); });
    document.querySelectorAll('[data-ds-minutes]').forEach(function (node) { node.firstChild.nodeValue = String(minutes).padStart(2, '0'); });
    document.querySelectorAll('[data-ds-seconds]').forEach(function (node) { node.firstChild.nodeValue = String(seconds).padStart(2, '0'); });
  }

  function initCampaign() {
    if (!active()) return;
    addStyles();
    document.querySelectorAll('.ds-anniversary-tile-badge,.ds-anniversary-badge').forEach(function (node) { node.remove(); });
    document.querySelectorAll('.ds-anniversary-tile,.ds-anniversary-badged').forEach(function (node) { node.classList.remove('ds-anniversary-tile', 'ds-anniversary-badged'); });
    installTileBadges();
    var rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    rootPath = rootPath.replace(/\/+$/, '') || '/';
    var currentPath = location.pathname.replace(/\/+$/, '') || '/';
    var isHomePage = currentPath === rootPath;
    function landingHasFinished() {
      var splash = document.querySelector('.shrine3d');
      return !splash || splash.style.display === 'none';
    }

    function installHomePopupWhenReady() {
      if (landingHasFinished()) {
        installPopup();
        return;
      }

      var installed = false;
      function finish() {
        if (installed) return;
        installed = true;
        document.removeEventListener('shrine:home-visible', finish);
        installPopup();
      }

      document.addEventListener('shrine:home-visible', finish, { once: true });
    }

    if (isHomePage) installHomePopupWhenReady();
    updateCountdowns();
    window.setInterval(updateCountdowns, 1000);
    var observer = new MutationObserver(function () { installTileBadges(); });
    var main = document.getElementById('main-content') || document.querySelector('main');
    if (main) observer.observe(main, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCampaign);
  else initCampaign();
})();
